import 'babel-polyfill';
import createFocusTrap from 'focus-trap/index.js';
import { PinClickEvent, PinHoverEvent, CardHoverEvent, CardClickEvent } from './Events.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { Maps } from 'js/components/Maps/index.js';
import { SearchMap } from 'js/search/modules/MapboxGL.js';

export class CobaltMap extends SearchMap {
  static initClass() {
    Maps.FactoryForProvider.MapboxGL = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.CobaltMap";
    this.breakPoint = 992;
  }

  constructor(args) {
    super(args);
    this.pinHeight = 45;
    this.pinWidth = 34;
  }

  calcOffset() {
    return 10;
  }

  iconImage(loc, i, backgroundColor, textColor) {
    return `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1))}`;
  }

  registerResultHandlers() {
    registerResultHandlers();
  }

  removePins() {
    for (let pin of this.pins) {
      pin.remove();
    }
    this.pins = [];
  }

  svgPin(label, isActive){
    let textPos;
    if(isActive == null){
      if (label < 10){
        textPos = 'x="10.107" y="19"';
      } else{
        textPos = 'x="7.107" y="19"';
      }

      return `
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="48" viewBox="0 0 28 48">
          <g fill="none" fill-rule="evenodd">
              <path fill="#1070D4" fill-rule="nonzero" d="M14 48c.67 0 1.007-.333 1-1 .5-18 13-23 13-33 0-8-6-14-14-14S0 6 0 14c0 10 12.5 15 13 33 0 .66.33 1 1 1z"/>
              <path fill-rule="nonzero" stroke="#12131E" d="M14 47.5c.395 0 .504-.109.5-.514.212-7.633 2.304-13.052 6.576-19.47.33-.496.666-.99 1.111-1.639a901.059 901.059 0 0 1 1.077-1.567c.843-1.233 1.422-2.126 1.936-3.001 1.553-2.646 2.3-4.876 2.3-7.309C27.5 6.276 21.724.5 14 .5S.5 6.276.5 14c0 2.433.747 4.663 2.3 7.309.514.875 1.093 1.768 1.936 3.001a236.62 236.62 0 0 0 1.077 1.567c.445.648.782 1.143 1.111 1.638C11.196 33.935 13.288 39.353 13.5 47c0 .389.11.5.5.5z" opacity=".5"/>
              <text fill="#FFF" font-family="Arial-BoldMT, Arial" font-size="14" font-weight="bold">
                  <tspan ${textPos}>${label}</tspan>
              </text>
          </g>
      </svg>
      `;
    }else{
      if (label < 10){
        textPos = 'x="11.995" y="22.625"';
      } else{
        textPos = 'x="7.995" y="22.625"';
      }


      return `
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="58" viewBox="0 0 34 58">
          <g fill="none" fill-rule="evenodd">
              <path fill="#FFF" fill-rule="nonzero" d="M17 58c.814 0 1.223-.403 1.214-1.208C18.821 35.042 34 29 34 16.917 34 7.25 26.714 0 17 0S0 7.25 0 16.917C0 29 15.179 35.042 15.786 56.792c0 .798.4 1.208 1.214 1.208z"/>
              <path fill-rule="nonzero" stroke="#DC291E" stroke-width="2" d="M17 57c.263 0 .217.046.215-.236.26-9.309 2.826-15.924 8.052-23.738.4-.6.81-1.199 1.352-1.984l.662-.956.646-.936c1.018-1.484 1.717-2.556 2.336-3.604 1.852-3.141 2.737-5.77 2.737-8.63C33 7.804 26.163 1 17 1S1 7.803 1 16.917c0 2.859.885 5.488 2.737 8.629.619 1.048 1.318 2.12 2.336 3.604l.646.936.662.956c.542.785.951 1.384 1.352 1.984 5.226 7.814 7.792 14.429 8.053 23.766 0 .25-.043.208.214.208z"/>
              <text fill="#DC291E" font-family="Arial-BoldMT, Arial" font-size="18" font-weight="bold">
                  <tspan ${textPos}>${label}</tspan>
              </text>
          </g>
      </svg>
      `;
    }
  }

  scrollToLoc(loc) {
    const searchBoxHeight = $('.Locator-title').innerHeight() + $('.Locator-searchTitle').innerHeight()
                          + $('.Locator-searchWrapper').innerHeight() + $('.Locator-resultsSummary').innerHeight();
    const scrollHeight = $('.Locator-content').scrollTop() + $(`#js-yl-${loc.id}`).position().top - searchBoxHeight;
    $('.Locator-content').animate({scrollTop: scrollHeight}, 500);
  }


  updateMap(options = {}) {
    let boundsOptions = Object.assign({}, this.boundsOptions);

    const map = this.map;
    let marker;
    this.bounds = new mapboxgl.LngLatBounds();
    let idx = 0;
    for (let location of Array.from(this.allLocations)) {
      let coord = new mapboxgl.LngLat(location.longitude, location.latitude);
      marker = this.preparePin(idx, location, map, coord);

      this.pins.push(marker);
      this.bounds.extend(coord);
      idx++;
    }
    if (options.keepCenterVisible) {
      this.bounds.extend(map.getCenter());
      boundsOptions.animate = true;
      boundsOptions.linear = false;
      boundsOptions.duration = 300;
    }

    if (this.allLocations.length > 0) {
      this.options.center = this.bounds.getCenter();
    } else {
      this.options.center = new mapboxgl.LngLat(this.longitude, this.latitude);
      this.options.zoom = 3;
    }

    if (this.pins.length > 0) {
      for (marker of Array.from(this.pins)) {
        marker.addTo(map);
      }
      map.fitBounds(this.bounds, boundsOptions);
    }
  }

  prepareMap() {
    const map = super.prepareMap();
    this.constructor.map = map;
    return map;
  }

  preparePin(i, loc, map, latLng) {
    let wrapper = document.createElement('div');
    let button = document.createElement('button');
    button.className = 'custom-icon-button';
    let icon = $(this.svgPin(i+1));
    let activeIcon = $(this.svgPin(i+1, true));
    let image = icon[0];
    let activeImage = activeIcon[0];

    button.setAttribute('data-lon', loc.longitude);
    button.setAttribute('data-lat', loc.latitude);

    button.addEventListener('mouseover', () => {
      button.classList.add('is-hovered');
      wrapper.isHovered = true;
      document.dispatchEvent(new PinHoverEvent(`js-yl-${loc.id}`, true));
    });
    button.addEventListener('mouseout', () => {
      button.classList.remove('is-hovered');
      wrapper.isHovered = false;
      document.dispatchEvent(new PinHoverEvent(`js-yl-${loc.id}`, false));
    })

    button.addEventListener('click', () => {
      document.dispatchEvent(new PinClickEvent(`js-yl-${loc.id}`));
    });

    button.appendChild(image);
    wrapper.appendChild(button);
    wrapper.className = 'custom-icon js-custom-icon';

    wrapper.isHovered = false;
    wrapper.isSelected = false;

    document.addEventListener(PinClickEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget) {
        this.scrollToLoc(loc);
        button.classList.add('is-selected');
        if(button.contains(image)){
          button.removeChild(image);
          button.appendChild(activeImage);
        }
        wrapper.isSelected = true;
      } else {
        button.classList.remove('is-selected');
        button.classList.remove('is-hovered');
        if(button.contains(activeImage)){
          button.removeChild(activeImage);
          button.appendChild(image);
        }
        wrapper.isSelected = false;
        wrapper.isHovered = false;
      }
    });

    document.addEventListener(CardHoverEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget && event.detail.active) {
        button.classList.add('is-hovered');
        wrapper.isHovered = true;
      } else {
        button.classList.remove('is-hovered');
        wrapper.isHovered = false;
      }
    });

    document.addEventListener(CardClickEvent.eventTypeName, event => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget) {
        this.scrollToLoc(loc);
        button.classList.add('is-selected');
        if(button.contains(image)){
          button.removeChild(image);
          button.appendChild(activeImage);
        }

        wrapper.isSelected = true;
        const bounds = map.getBounds();
        const preBounds = bounds.toString();
        const afterBounds = bounds.extend(latLng).toString();
        if (preBounds != afterBounds) {
          map.panTo(latLng);
        }
      } else {
        button.classList.remove('is-hovered');
        button.classList.remove('is-selected');
        if(button.contains(activeImage)){
          button.removeChild(activeImage);
          button.appendChild(image);
        }
        wrapper.isSelected = false;
        wrapper.isHovered = false;
      }
    });

    document.addEventListener(PinHoverEvent.eventTypeName, (event) => {
      if (wrapper.isSelected) { return; }
      const currentlyHovered = event.detail.yextId == `js-yl-${loc.id}` && event.detail.active;
      if (!wrapper.isHovered && currentlyHovered) {
        button.classList.add('is-hovered');
        wrapper.isHovered = true;
        wrapper.style.zIndex = "1";
      } else if (wrapper.isHovered && !currentlyHovered) {
        button.classList.remove('is-hovered');
        wrapper.isHovered = false;
        wrapper.style.zIndex = "0";
      }
    });

    let marker = new mapboxgl.Marker(wrapper, {offset: new mapboxgl.Point(-this.pinWidth/2, -this.pinHeight/2)}).setLngLat(latLng);
    return marker;
  }
}
CobaltMap.initClass();

let registerResultHandlers = function() {
  let results = document.getElementsByClassName('js-location-result');
  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseover', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), true));
    });
    result.addEventListener('mouseout', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), false));
    });
  }
};

let registerDocumentHandlers = function() {
  document.addEventListener(PinClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (id == null) { return; }
    const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
    if (minWidthSearchMapBreakPointQuery.matches) {
      document.getElementById(id).classList.add('is-selected');
    }
    let toRemove = document.querySelectorAll(`.js-location-result.is-selected:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
      toChange.classList.remove('is-hovered');
    }

    const isIE11 =!!window.MSInputMethodContext && !!document.documentMode;
    const stickyHeight = isIE11 ? 0 : document.querySelector('.Locator-searchWrapper').offsetHeight;

    const targetEl = document.getElementById(id);

    if (document.querySelector('html').classList.contains('chaz')) {
      function isScrolledIntoView(elem) {
        const offTop = window.scrollY + stickyHeight > $(elem).offset().top;
        const offBottom = $(elem).offset().top + elem.offsetHeight > window.scrollY + window.innerHeight;
        return !(offTop || offBottom);
      }

      if (!isScrolledIntoView(targetEl)) {
        $('html ,body').animate({
          scrollTop: $(targetEl).offset().top - stickyHeight,
        }, {duration: 600, queue: false});
      }
    } else if (document.querySelector('html').classList.contains('ace')) {
      const container = document.querySelector('.Locator-content');
      function isScrolledIntoView(elem) {
        const elBottom = $(elem).position().top + elem.offsetHeight;
        return (elBottom <= container.offsetHeight) && ($(elem).position().top >= stickyHeight);
      }

      if (!isScrolledIntoView(targetEl)) {
        $('.Locator-content').animate({
            scrollTop: container.scrollTop + $(targetEl).offset().top - document.querySelector('header').offsetHeight - stickyHeight,
        }, {duration: 600, queue: false});
      }
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (!id) { return; }
    const targetEl = document.getElementById(id);
    let selector = `.js-location-result.is-selected`;
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
    }
    targetEl.classList.add('is-selected');
  });

  document.addEventListener(PinHoverEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    const targetEl = document.getElementById(id);
    if (e.detail.active) {
      targetEl.classList.add('is-hovered');
    }
    let selector = `.js-location-result.is-hovered`;
    if (e.detail.active) {
      selector += `:not(#${id})`;
    }
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-hovered');
    }
  });
};


export const MapSetup = () => {
  registerResultHandlers();
  registerDocumentHandlers();
}
